import { FeatureFlagsContext } from '@contexts/FeatureFlagsContext';
import { useAppSelector } from '@hooks/generic';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { Avatar, Badge } from '@mui/material';
import { selectTitle } from '@store/appSlice';
import { useContext } from 'react';

const UserNavbar = () => {
    const title = useAppSelector(selectTitle);

    const featureFlags = useContext(FeatureFlagsContext);
    return (
        <div id="user-navbar" className="p-5 flex justify-between items-center gap-5 bg-white">
            {title ? <h1 className="text-4xl font-bold tracking-tight font-roboto">{title}</h1> : null}
            {featureFlags.showProfile ? (
                <>
                    <Badge color="error" variant="dot">
                        <NotificationsOutlinedIcon fontSize="large" />
                    </Badge>
                    <div className="flex font-roboto">
                        <div>
                            <p className="font-bold">John Doe</p>
                            <p className="text-gray-500">Sales Manager</p>
                        </div>
                        <Avatar alt="Profile" src="/vite.svg" />
                    </div>
                </>
            ) : null}
        </div>
    );
};

export { UserNavbar };
